import React, {Component} from 'react'
import {Card, CardHeader, CardBody} from 'reactstrap'
import BigCalendar from 'react-big-calendar'
import moment from 'moment'
import {Query} from 'react-apollo'
import 'react-big-calendar/lib/css/react-big-calendar.css'

import QUERY from '../../../queries/server/user_schedules'

moment.locale('gb')

// Setup the localizer by providing the moment (or globalize) Object
// to the correct localizer.
const localiser = BigCalendar.momentLocalizer(moment) // or globalizeLocalizer



export default class Agenda extends Component{

    getEvents = (data) => {

        if(!data || !data.length) return []

        return data.map(schedule => {
            return {
                id: schedule.id,
                title: schedule.project_activity_budget ? `${schedule.project_activity_budget.project_id}: ${schedule.project_activity_budget.project.name}` : 'No Title',
                start: moment(schedule.start_date).toDate(),
                end: moment(schedule.end_date).toDate()
            }
        })
    }

    render(){

        const {user_id} = this.props

        return (
            <Query query={QUERY} variables={{user_id}} fetchPolicy="network-only">
                {({loading, error, data}) => {

                    if(loading) return <h1>Loading...</h1>

                    const events = this.getEvents(data.user.schedules)

                    console.log(events)

                    return (
                        <BigCalendar
                            views={['agenda']}
                            defaultView={'agenda'}
                            localizer={localiser}
                            events={events}
                            startAccessor="start"
                            endAccessor="end"
                        />
                    )
                }}
            </Query>
        )
    }

}